import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_PROCON } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { CadastraAtendimentoPfRequest, Types } from './types';

// ACTIONS
import {
	cadastraAtendimentoPfSuccess,
	cadastraAtendimentoPfFailure,
} from './actions';

function* cadastraAtendimentoPfRequest(request: ReducerAction) {
	const { payload }: { payload: CadastraAtendimentoPfRequest } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_PROCON,
		`atendimentos-cip/${CHANNEL}/consumidores-pf/cip`,
		payload,
	);

	if (response.status === 200 || response.status === 201) {
		yield put(cadastraAtendimentoPfSuccess(response));
	} else {
		yield put(cadastraAtendimentoPfFailure(response));
	}
}

export default all([
	takeLatest(
		Types.CADASTRA_ATENDIMENTO_PF_REQUEST,
		cadastraAtendimentoPfRequest,
	),
]);
